import Fetch from "utils/fetch";

export const searchAllMaterials = (idFamiliaRotuladaCentro) => {
    return Fetch.get(`/material/obterPorFamiliaRotuladaCentro/${idFamiliaRotuladaCentro}`).then(({ data }) => data)
}

export const buscaUsuariosAmbev = () => {
    return Fetch.get(`/usuario/buscaUsuariosHabilitadoAmbev`).then(({ data }) => data)
}